import React from 'react';
import { Button, Modal, Form, Row, Col } from 'react-bootstrap';

interface ColumnOption {
  field: string;
  label: string;
  filterable?: boolean;
  show: boolean;
  systemHidden?: boolean;
}

interface ColumnSettingsModalProps {
  show: boolean;
  columnOptions: ColumnOption[];
  selectedFields: string[];
  requiredFields: string[];
  minRequired: number;
  onToggleField: (field: string) => void;
  onCancel: () => void;
  onSave: () => void;
}

export const ColumnSettingsModal: React.FC<ColumnSettingsModalProps> = ({
  show,
  columnOptions,
  selectedFields,
  requiredFields,
  minRequired,
  onToggleField,
  onCancel,
  onSave,
}) => (
  <Modal
    show={show}
    onHide={onCancel}
    centered
    enforceFocus={false}
    restoreFocus={false}
  >
    <Modal.Header closeButton>
      <Modal.Title>Column settings</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row>
        {columnOptions
          .filter(option => !option.systemHidden)
          .map(option => (
            <Col key={option.field} xs={12} md={6} className="mb-2">
              <Form.Check
                type="checkbox"
                id={`column-${option.field}`}
                label={option.label}
                checked={selectedFields.includes(option.field)}
                onChange={() => onToggleField(option.field)}
                disabled={
                  option.filterable &&
                  selectedFields.includes(option.field) &&
                  selectedFields.filter(field => requiredFields.includes(field))
                    .length <= minRequired
                }
              />
            </Col>
          ))}
      </Row>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onSave}>
        Save
      </Button>
    </Modal.Footer>
  </Modal>
);
